import type { AuthorityState, Document, SourceAuthorityMetadata } from '@agentwiki/shared'

export function deriveEffectiveAuthorityState(
  storedState: AuthorityState,
  expiresAt: number | null | undefined,
  now = Date.now(),
) {
  if (expiresAt !== null && expiresAt !== undefined && expiresAt <= now) return 'expired'
  return storedState
}

export function getDocumentSourceAuthorityMetadata(doc: Document): SourceAuthorityMetadata | null {
  const source = doc.sourceProvenance
  if (!source?.sourceId || !source.authorityState) return null
  return {
    sourceId: source.sourceId,
    documentId: doc.id,
    authorityState: source.authorityState,
    effectiveAuthorityState: deriveEffectiveAuthorityState(
      source.authorityState,
      source.authorityExpiresAt,
    ),
    authorityExpiresAt: source.authorityExpiresAt ?? null,
    authorityReviewedAt: source.authorityReviewedAt ?? null,
  }
}
